import { 
  Navigation2, Crosshair, Landmark, Zap, 
  Trees, StopCircle, Train, Plus,
  Circle, FileText
} from 'lucide-react';

export const POI_TYPES = {
  Road: {
    color: '#3B82F6',
    prefix: 'RD',
    icon: Navigation2
  },
  Intersection: {
    color: '#EF4444',
    prefix: 'IN',
    icon: Crosshair
  },
  Bridge: {
    color: '#F59E0B',
    prefix: 'BR',
    icon: Landmark
  },
  PowerLine: {
    color: '#10B981',
    prefix: 'PL',
    icon: Zap
  },
  Trees: {
    color: '#047857',
    prefix: 'TR',
    icon: Trees
  },
  Signalization: {
    color: '#6366F1',
    prefix: 'SG',
    icon: StopCircle
  },
  Railroad: {
    color: '#7C3AED',
    prefix: 'RR',
    icon: Train
  },
  Custom: {
    color: '#6B7280',
    prefix: 'CU',
    icon: Plus
  },
  File: {
    color: '#6366F1',
    prefix: 'FL',
    icon: FileText
  },
  Profile: {
    color: '#8B5CF6',
    prefix: 'PR',
    icon: FileText
  }
};